import { tw } from '@/utils/tw';

const VideoPlaylist = tw.theme({
  base: [
    '[&_[class^="swiper-button-prev-"]::after]:tracking-normal',
    '[&_[class^="swiper-button-next-"]::after]:tracking-normal',
    'aller-video-container',
    'group-[]/front:h-[calc((100vw-56px)*1.777/2.15+37px)]',
    'group-[]/front:[@media(min-width:480px)]:h-[calc((100vw-68px)*1.777/2.2+37px)]',
    'group-[]/front:[@media(min-width:736px)]:h-[calc((100vw-84px)*1.777/3.75+37px)]',
    'group-[]/front:[@media(min-width:736px)]:max-h-[485px]',
  ],
});

export default VideoPlaylist;
